import { FileText, Link2, KeyRound, X } from 'lucide-react'

function iconForMedia(media) {
  if (media?.type === 'url') return Link2
  if (media?.kind === 'license') return KeyRound
  return FileText
}

export default function ContentChip({ label, media, onRemove, onClick }) {
  const Icon = iconForMedia(media)

  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-2 border border-gray-200 bg-[#fcfdff] rounded-md px-2.5 py-2 m-0.5 text-xs text-gray-900 hover:border-blue-300 max-w-full"
      title={label}
    >
      <Icon className="size-3.5 shrink-0 text-gray-500" />
      <span className="truncate max-w-[180px]">{label}</span>
      {onRemove && (
        <span
          role="button"
          tabIndex={0}
          className="text-gray-400 hover:text-red-500 shrink-0"
          onClick={(e) => {
            e.stopPropagation()
            onRemove()
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.stopPropagation()
              onRemove()
            }
          }}
        >
          <X className="size-3.5" />
        </span>
      )}
    </button>
  )
}
